import Reports from 'containers/reports/Reports';

export default Reports;
